import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMaterialsMenuIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.2951 7.97658C13.4513 7.97658 13.5764 7.97658 13.7326 7.94084L18.0144 6.51128V12.8728C18.0144 13.4089 17.7018 13.8735 17.233 13.9807L10.4823 15.9464C10.1697 16.0179 9.82594 16.0179 9.5134 15.9464L2.76263 13.9807C2.32508 13.8735 2.01254 13.4089 2.01254 12.8728V6.51128L6.29428 7.94084C6.4193 7.97658 6.54431 8.01232 6.70058 8.01232C7.23189 8.01232 7.73195 7.69067 7.98198 7.15458L10.0135 3.3305L12.0137 7.15458C12.2637 7.65493 12.7638 7.97658 13.2951 7.97658ZM19.9521 3.97381C20.0771 4.29546 19.9521 4.68859 19.6396 4.79581L13.4513 6.83293C13.2326 6.90441 12.9825 6.79719 12.8575 6.58276L10.0135 1.11468L17.8268 0.00677256C18.0456 -0.0289665 18.2331 0.0782507 18.3269 0.292685L19.9521 3.97381ZM1.66875 0.292685C1.76251 0.0782507 1.95004 -0.0289665 2.16881 0.00677256L10.0135 1.11468L7.13813 6.54702C7.01311 6.79719 6.76309 6.90441 6.54431 6.83293L0.356104 4.79581C0.0748216 4.68859 -0.0814462 4.29546 0.0435681 3.97381L1.66875 0.292685Z",
		fill: "#AAAAAA"
	})
});
export default SvgMaterialsMenuIcon;
